/* eslint-disable react/forbid-dom-props */
import React from 'react';
import { ShieldCheck, ShieldAlert, AlertTriangle } from 'lucide-react';

/**
 * Painel compacto do quality gate jurídico (petitions.quality_report).
 * Critical em vermelho, warning em amarelo, ok discreto — some quando a
 * versão não tem relatório (ex.: revisão subida manualmente pelo revisor).
 */
export default function QualityPanel({ report }) {
  if (!report || !Array.isArray(report.checks)) return null;

  const failed = report.checks.filter(c => c.status === 'failed');
  const criticals = failed.filter(c => c.severity === 'critical');
  const warnings = failed.filter(c => c.severity === 'warning');
  const passed = report.checks.filter(c => c.status === 'ok').length;
  const alerts = report.alerts || [];

  const tone = criticals.length
    ? { color: 'var(--error)', bg: 'var(--error-bg)', label: 'Pendências críticas', Icon: ShieldAlert }
    : warnings.length
    ? { color: '#875708', bg: 'var(--warning-bg)', label: 'Pontos de atenção', Icon: AlertTriangle }
    : { color: 'var(--success)', bg: 'var(--success-bg)', label: 'Checks aprovados', Icon: ShieldCheck };

  return (
    <div className="card">
      <div className="card-header">
        <tone.Icon size={15} style={{ color: tone.color }} />
        <span className="card-title">Qualidade da petição</span>
        <span
          className="badge"
          style={{ marginLeft: 'auto', background: tone.bg, color: tone.color, fontWeight: 600 }}
        >
          {report.score}/100
        </span>
      </div>

      <div style={{ fontSize: '.75rem', color: 'var(--text-muted)', marginBottom: failed.length || alerts.length ? '.625rem' : 0 }}>
        {tone.label}: {passed} de {report.checks.length} checks automáticos passaram.
      </div>

      {failed.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '.45rem' }}>
          {[...criticals, ...warnings].map(c => (
            <div key={c.id} style={{ display: 'flex', gap: '.45rem', alignItems: 'flex-start' }}>
              <span
                aria-hidden="true"
                style={{
                  width: 7, height: 7, borderRadius: '50%', marginTop: 5, flexShrink: 0,
                  background: c.severity === 'critical' ? 'var(--error)' : 'var(--warning)',
                }}
              />
              <div style={{ minWidth: 0 }}>
                <div style={{
                  fontSize: '.775rem', fontWeight: 600,
                  color: c.severity === 'critical' ? 'var(--error)' : '#875708',
                }}>
                  {c.label}
                </div>
                <div style={{ fontSize: '.73rem', color: 'var(--text-secondary)', lineHeight: 1.45 }}>
                  {c.message}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {alerts.length > 0 && (
        <div style={{
          marginTop: '.625rem', padding: '.5rem .625rem', background: 'var(--warning-bg)',
          border: '1px solid #f0d080', borderRadius: 'var(--radius-sm)',
          fontSize: '.73rem', color: '#875708', display: 'flex', flexDirection: 'column', gap: '.25rem',
        }}>
          {alerts.map((a, i) => <span key={i}>{a}</span>)}
        </div>
      )}
    </div>
  );
}
